import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import html2canvas from 'html2canvas';
import { fontFaces } from '../../../../assets/fonts/fonts';
import Logo from "../../../../styles/img/CompliNYC-Logo.png";
import toast from 'react-hot-toast';

/**
 * Generates a Property Service PDF report
 * @param {Array} buildingsData - Array of buildings with their service data
 * @param {string} clientName - Name of the client
 * @returns {Promise<jsPDF>} - PDF document
 */
export const generateAnnualComplianceSignUpPDF = async (buildingsData, clientName) => {
  console.log(buildingsData, clientName);
  if (!buildingsData || buildingsData.length === 0) {
    return toast.error("No buildings found for this Client");
    // throw new Error("Missing required data for PDF generation");
  }

  // Create PDF document
  const doc = new jsPDF();
  
  // Create table page
  await createPropertyServiceTablePage(doc, buildingsData, clientName);
  
  return doc;
};

/**
 * Creates a property service table page from HTML
 * @param {jsPDF} doc - The PDF document
 * @param {Array} buildingsData - Array of buildings with their service data
 * @param {string} clientName - Name of the client
 */
const createPropertyServiceTablePage = async (doc, buildingsData, clientName) => {
  // Define how many rows per page
  const ROWS_PER_PAGE = 10;
  
  // Calculate total pages needed
  const totalPages = Math.ceil(buildingsData.length / ROWS_PER_PAGE);
  
  // Process each page
  for (let pageNum = 0; pageNum < totalPages; pageNum++) {
    // If not the first page, add a new page
    if (pageNum > 0) {
      doc.addPage();
    }
    
    // Slice the data for current page
    const startIndex = pageNum * ROWS_PER_PAGE;
    const endIndex = Math.min(startIndex + ROWS_PER_PAGE, buildingsData.length);
    const currentPageData = buildingsData.slice(startIndex, endIndex);
    
    // Create a temporary div to hold our HTML
    const tempDiv = document.createElement("div");
    tempDiv.style.position = "absolute";
    tempDiv.style.left = "-9999px";
    tempDiv.style.top = "-9999px";
    tempDiv.style.width = "794px"; // A4 width in pixels at 96 DPI

    // Define SVG as a string
    const unCheckedSvgString = `
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
<rect x="0.5" y="0.5" width="23" height="23" rx="3.5" fill="white" stroke="#919EAB"/>
</svg>
    `;

    const checkedSvgString = `<svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
<rect x="2.5" y="2.5" width="23" height="23" rx="3.5" fill="#00B8D9" stroke="#00B8D9"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M21.707 9.28007C21.8946 9.45945 22 9.70271 22 9.95635C22 10.21 21.8946 10.4533 21.707 10.6326L12.1996 19.7199C12.0119 19.8993 11.7574 20 11.492 20C11.2266 20 10.9721 19.8993 10.7845 19.7199L6.28093 15.4154C6.09863 15.235 5.99776 14.9934 6.00004 14.7426C6.00232 14.4918 6.10757 14.2519 6.29312 14.0745C6.47868 13.8972 6.72968 13.7966 6.99209 13.7944C7.25449 13.7922 7.50729 13.8886 7.69604 14.0629L11.492 17.6911L20.2919 9.28007C20.4796 9.10074 20.7341 9 20.9994 9C21.2648 9 21.5193 9.10074 21.707 9.28007Z" fill="white" stroke="white" stroke-width="0.8"/>
</svg>
    `;
    
    // Create HTML content for property service table page
    tempDiv.innerHTML = `
      <style>
        ${fontFaces}
        
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }
        
        table {
          border-collapse: collapse;
          width: 100%;
          border: 1px solid #E5E7EC;
          border-radius: 8px;
          box-shadow: 0px 12px 23px 0px #3E49540A;
        }
        
        th, td {
          padding: 12px;
          text-align: left;
        }

        thead {
          background-color: #F5F5F9;
          border-radius: 8px 8px 0 0;
        }
        
        th {
          
          color: #1B3E61;
          font-family: "segoe_uisemibold";
          font-size: 14px;  
        
        }
        
        tr:nth-child(even) {
          background-color: #F9FAFB;
        }
        
        .service-check {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      </style>
      <div style="width: 794px; height: 1123px; padding: 40px; font-family: 'Segoe UI Regular', sans-serif; position: relative; box-sizing: border-box; background-color: white;">
      <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 30px;">
      <img src="${Logo}" style="width: 180px;">
      </div>
        <!-- Title -->
        <div style="text-align: center; margin-bottom: 30px;">
          <h1 style="color: #16304F; font-size: 32px; font-weight: bold; margin: 0; font-family: 'Segoe UI Bold'; text-transform: uppercase;">Annual Compliance Sign Up</h1>
        </div>
        
        <!-- Horizontal line -->
        <div style="width: 100%; height: 1px; background-color: #EEEEEE; margin: 20px 0;"></div>
        
        <!-- Client Name -->
        <div style="text-align: center; margin: 30px 0;">
          <p style="color: #637381; font-size: 18px; margin: 0; font-family: 'Segoe UI Regular';">Client: <span style="font-family: 'segoe_uisemibold';">${clientName}</span></p>
        </div>
        
        <!-- Page indicator -->
        <div style="text-align: right; margin-bottom: 10px;">
          <p style="color: #637381; font-size: 12px; font-family: 'Segoe UI Regular';">Page ${
            pageNum + 1
          } of ${totalPages}</p>
        </div>
        
        <!-- Table -->
        <table style="width: 100%; margin-top: 10px; border-collapse: collapse;">
          <thead>
            <tr>
              <th style="width: 5%; text-align: left; padding: 12px; font-family: 'segoe_uisemibold';">#</th>
              <th style="width: 36%; text-align: left; padding: 12px; font-family: 'segoe_uisemibold';">Building</th>
              <th style="width: 10%; text-align: center; padding: 12px; font-family: 'segoe_uisemibold';">#Units</th>
              <th style="width: 9%; text-align: center; padding: 12px; font-family: 'segoe_uisemibold';">Annual</th>
            </tr>
          </thead>
          <tbody>
            ${currentPageData
              .map(
                (building, index) => `
               <tr>
                <td style="padding: 12px; font-family: 'Segoe UI Regular';">${
                  startIndex + index + 1
                }</td>
                <td style="padding: 12px; font-family: 'Segoe UI Regular';">${
                  building.address
                }</td>
                <td style="padding: 12px; text-align: center; font-family: 'Segoe UI Regular';">${
                  building.units
                }</td>
                <td style="padding: 12px; text-align: center;">
                  ${
                    building.services.annual
                      ? `<div class="service-check">${checkedSvgString}</div>`
                      : `<div class="service-check">${unCheckedSvgString}</div>`
                  }
                </td>
               </tr>
            `
              )
              .join("")}
          </tbody>
        </table>
        
       
      </div>
    `;
    
    // Add the div to the document
    document.body.appendChild(tempDiv);
    
    try {
      // Wait for fonts to load
      await document.fonts.ready;
      
      // Convert HTML to canvas
      const canvas = await html2canvas(tempDiv, {
        scale: 2, // Higher scale for better quality
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        allowTaint: true,
        onclone: (clonedDoc) => {
          // This function is called with the cloned document
          // You can use it to ensure fonts are loaded in the clone
          const style = clonedDoc.createElement("style");
          style.innerHTML = fontFaces;
          clonedDoc.head.appendChild(style);
        },
      });
      
      // Add the canvas image to the PDF
      const imgData = canvas.toDataURL("image/png");
      doc.addImage(imgData, "PNG", 0, 0, 210, 297); // A4 size in mm
    } catch (error) {
      console.error("Error generating HTML to PDF:", error);
    } finally {
      // Clean up
      document.body.removeChild(tempDiv);
    }
  }
  
  // Handle case when there's no data
  if (buildingsData.length === 0) {
    // Create a temporary div for empty state
    const tempDiv = document.createElement("div");
    tempDiv.style.position = "absolute";
    tempDiv.style.left = "-9999px";
    tempDiv.style.top = "-9999px";
    tempDiv.style.width = "794px"; // A4 width in pixels at 96 DPI
    
    tempDiv.innerHTML = `
      <style>
        ${fontFaces}
        * {
          box-sizing: border-box;
          margin: 0;
          padding: 0;
        }
      </style>
      <div style="width: 794px; height: 1123px; padding: 40px; font-family: 'Segoe UI Regular', sans-serif; position: relative; box-sizing: border-box; background-color: white;">
       <div style="display: flex; justify-content: center; align-items: center; margin-bottom: 30px;">
      <img src="${Logo}" style="width: 180px;">
      </div>
        <!-- Title -->
        <div style="text-align: centre; margin-bottom: 30px;">
          <h1 style="color: #16304F; font-size: 32px; font-weight: bold; margin: 0; font-family: 'Segoe UI Bold'; text-transform: uppercase;">PROPERTY SERVICE REPORT</h1>
        </div>
        
        <!-- Horizontal line -->
        <div style="width: 100%; height: 1px; background-color: #EEEEEE; margin: 20px 0;"></div>
        
        <!-- Client Name -->
        <div style="text-align: center; margin: 30px 0;">
          <p style="color: #637381; font-size: 18px; margin: 0; font-family: 'Segoe UI Regular';">Client: <span style="font-family: 'segoe_uisemibold';">${clientName}</span></p>
        </div>
        
        <!-- Empty state message -->
        <div style="text-align: center; margin-top: 100px;">
          <p style="color: #637381; font-size: 16px; font-family: 'Segoe UI Regular';">No buildings available for this client.</p>
        </div>
        
      </div>
    `;
    
    document.body.appendChild(tempDiv);
    
    try {
      await document.fonts.ready;
      const canvas = await html2canvas(tempDiv, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        allowTaint: true,
        onclone: (clonedDoc) => {
          const style = clonedDoc.createElement("style");
          style.innerHTML = fontFaces;
          clonedDoc.head.appendChild(style);
        },
      });
      
      const imgData = canvas.toDataURL("image/png");
      doc.addImage(imgData, "PNG", 0, 0, 210, 297);
    } catch (error) {
      console.error("Error generating empty HTML to PDF:", error);
    } finally {
      document.body.removeChild(tempDiv);
    }
  }
}; 